/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Contact { 
    id?: string;
    partner: string;
    civility: string;
    name: string;
    firstname: string;
    fonction?: string;
    email: string;
    phone?: string;
    invoicing?: boolean;
    company: string;
}